import FullscreenSpinner from "./FullscreenSpinner";

export default FullscreenSpinner;
